import { Component, OnInit } from '@angular/core';
import { IRep, RepsService } from '../reps.service';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserPermissions } from 'src/app/api-authorization/user-permissions.service';
import { boolean } from 'mathjs';

@Component({
  selector: 'app-rep-permissions',
  templateUrl: './rep-permissions.component.html',
  styleUrls: ['./rep-permissions.component.scss']
})
export class RepPermissionsComponent {

  subscriptions: Subscription = new Subscription();
  selectedRep: IRep | null = null;
  permissions: UserPermissions | null = null;
  AllContractColumns: boolean = false;

  constructor(private repsService: RepsService, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.subscriptions.add(this.repsService.selectedRep.subscribe(data => {
      this.selectedRep = data;
      console.log(data);
      if (data) {
        this.repsService.getPermissions(data.Id).subscribe(d => {
          this.permissions = d;
        });
      }
      else {
        this.resetForm();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  resetForm() {
    this.permissions = null;
  }

  save() {
    // console.log("save");
    if (this.selectedRep == null || this.permissions == null) {
      return;
    }
    this.repsService.savePermissions(this.selectedRep.Id, this.permissions).subscribe();
  }


  allComplete: boolean = false;

  updateAllComplete() {
    // this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (!this.permissions) {
      return false;
    }

    // return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
    return this.columns().filter(x => x).length > 0 && !this.AllContractColumns;
  }

  setAll(completed: boolean) {
    this.AllContractColumns = completed;

    if (!this.permissions) {
      return;
    }

    this.permissions.ContractsTab.JobName.Visible = completed;
    this.permissions.ContractsTab.Reference.Visible = completed;
    this.permissions.ContractsTab.ContractID.Visible = completed;
    this.permissions.ContractsTab.Total.Visible = completed;
    this.permissions.ContractsTab.Paid.Visible = completed;
    this.permissions.ContractsTab.Remaining.Visible = completed;
    this.permissions.ContractsTab.Rep.Visible = completed;
    this.permissions.ContractsTab.EstLabor.Visible = completed;
    this.permissions.ContractsTab.ActLabor.Visible = completed;
    this.permissions.ContractsTab.Hours.Visible = completed;
    this.permissions.ContractsTab.Est3rdParty.Visible = completed;
    this.permissions.ContractsTab.Act3rdParty.Visible = completed;
    this.permissions.ContractsTab.EstProfit.Visible = completed;
    this.permissions.ContractsTab.ActProfit.Visible = completed;
    this.permissions.ContractsTab.EstMargin.Visible = completed;
    this.permissions.ContractsTab.ActMargin.Visible = completed;
    this.permissions.ContractsTab.Month.Visible = completed;
    this.permissions.ContractsTab.Year.Visible = completed;
    this.permissions.ContractsTab.IsClosed.Visible = completed;
    this.permissions.ContractsTab.DocId.Visible = completed;
    this.permissions.ContractsTab.BilledAmount.Visible = completed;
    this.permissions.ContractsTab.Orders.Visible = completed;
    this.permissions.ContractsTab.JobNum.Visible = completed;
    this.permissions.ContractsTab.Size.Visible = completed;
    this.permissions.ContractsTab.Notes.Visible = completed;
    this.permissions.ContractsTab.Status.Visible = completed;
    this.permissions.ContractsTab.PermitStatus.Visible = completed;
    this.permissions.ContractsTab.WorkDays.Visible = completed;
    this.permissions.ContractsTab.ScheduleDate.Visible = completed;
    this.permissions.ContractsTab.ContractDate.Visible = completed;
    this.permissions.ContractsTab.ScheduleNotes.Visible = completed;
    this.permissions.ContractsTab.Crew.Visible = completed;
    this.permissions.ContractsTab.City.Visible = completed;
    this.permissions.ContractsTab.AttachmentCount.Visible = completed;
    this.permissions.ContractsTab.SpruceNotes.Visible = completed;
    this.permissions.ContractsTab.EstLaborMargin.Visible = completed;
    this.permissions.ContractsTab.ActLaborMargin.Visible = completed;
    this.permissions.ContractsTab.SpruceHours.Visible = completed;
  }

  columns() {

    if (!this.permissions) {
      return [];
    }

    const all: boolean[] = [this.permissions.ContractsTab.JobName.Visible,
    this.permissions.ContractsTab.Reference.Visible,
    this.permissions.ContractsTab.ContractID.Visible,
    this.permissions.ContractsTab.Total.Visible,
    this.permissions.ContractsTab.Paid.Visible,
    this.permissions.ContractsTab.Remaining.Visible,
    this.permissions.ContractsTab.Rep.Visible,
    this.permissions.ContractsTab.EstLabor.Visible,
    this.permissions.ContractsTab.ActLabor.Visible,
    this.permissions.ContractsTab.Hours.Visible,
    this.permissions.ContractsTab.Est3rdParty.Visible,
    this.permissions.ContractsTab.Act3rdParty.Visible,
    this.permissions.ContractsTab.EstProfit.Visible,
    this.permissions.ContractsTab.ActProfit.Visible,
    this.permissions.ContractsTab.EstMargin.Visible,
    this.permissions.ContractsTab.ActMargin.Visible,
    this.permissions.ContractsTab.Month.Visible,
    this.permissions.ContractsTab.Year.Visible,
    this.permissions.ContractsTab.IsClosed.Visible,
    this.permissions.ContractsTab.DocId.Visible,
    this.permissions.ContractsTab.BilledAmount.Visible,
    this.permissions.ContractsTab.Orders.Visible,
    this.permissions.ContractsTab.JobNum.Visible,
    this.permissions.ContractsTab.Size.Visible,
    this.permissions.ContractsTab.Notes.Visible,
    this.permissions.ContractsTab.Status.Visible,
    this.permissions.ContractsTab.PermitStatus.Visible,
    this.permissions.ContractsTab.WorkDays.Visible,
    this.permissions.ContractsTab.ScheduleDate.Visible,
    this.permissions.ContractsTab.ContractDate.Visible,
    this.permissions.ContractsTab.ScheduleNotes.Visible,
    this.permissions.ContractsTab.Crew.Visible,
    this.permissions.ContractsTab.City.Visible,
    this.permissions.ContractsTab.AttachmentCount.Visible,
    this.permissions.ContractsTab.SpruceNotes.Visible,
    this.permissions.ContractsTab.EstLaborMargin.Visible,
    this.permissions.ContractsTab.ActLaborMargin.Visible,
    this.permissions.ContractsTab.SpruceHours.Visible
  ];
    return all;
  }
}

